import React, { useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { FullTable } from 'components';
import { collectionActions, httpRequestsOnSuccessActions } from 'store';
import { FindSuccessItem, useModal } from 'utils';
import {
  ACTION_TYPE,
  actionEnums,
  COLLECT_LOAD_ACTION_TYPE,
  COLLECT_RESERVE_ACTION_TYPE,
  collectionBody,
  collectionHead,
} from './constants';
import { CollectLoads, CollectReserve } from './core';

export const ActiveCollections = ({}) => {
  const { collections } = useSelector((state) => ({
    collections: state.collections.collections,
  }));
  const history = useHistory();
  const info = history?.location?.state;
  const dispatch = useDispatch();
  const successReserve = FindSuccessItem(COLLECT_RESERVE_ACTION_TYPE);
  const successCollect = FindSuccessItem(COLLECT_LOAD_ACTION_TYPE);
  const { open, close } = useModal();

  const renderParams = () => {
    const filteredInfo = {
      ...info,
      hasDept: true
    };
    filteredInfo.skip = info?.skip ? info?.skip : 0;
    filteredInfo.limit = 100;
    delete filteredInfo.page;
    delete filteredInfo.activeTab;
    return filteredInfo;
  };

  useEffect(() => {
    handleGet('loading');
    const interval = setInterval(() => {
      handleGet('noLoad');
    }, 30000);
    return () => clearInterval(interval);
  }, [info]);

  useEffect(() => {
    if (successReserve) {
      close()
      handleGet('noLoad');
      dispatch(httpRequestsOnSuccessActions.removeSuccess(COLLECT_RESERVE_ACTION_TYPE));
    }
    if (successCollect) {
      handleGet('noLoad');
      dispatch(httpRequestsOnSuccessActions.removeSuccess(COLLECT_LOAD_ACTION_TYPE));
    }
  }, [successReserve, successCollect]);

  const handleGet = (loading) => {
    const loader = loading === 'loading' ? 'loading' : 'noLoad';
    const filteredInfo = renderParams();
    dispatch(collectionActions.getCollections({ ...filteredInfo }, loader));
  };

  const handleSubmit = (item, name ) => {
    if(name === actionEnums.COLLECT_RESERVE) {
      open(<CollectReserve carrier={item}/>)
    }
    if(name === actionEnums.COLLECT_LOAD) {
      open(<CollectLoads item={item}/>)
    }
  };

  return (
    <div>
      <FullTable
        head={collectionHead}
        body={collectionBody}
        loadingType={ACTION_TYPE}
        list={collections?.carriers}
        listCount={collections?.count}
        noText={'Collections'}
        handleClickButton={handleSubmit}
      />
    </div>
  );
};